import { useEffect } from 'react';
import { graphql, PageProps } from 'gatsby'
import { JsonLd } from 'react-schemaorg';
import { ProductModel } from 'schema-dts';

import Layout from '../../../components/layout'
import Seo from '../../../components/seo'
import SellingHeroFilter from '../../../components/SellingHero/SellingHeroFilter';
import { API_BASE_URL } from '../../../utils/api';
import { initialStore, Provider, useStore } from '../../../utils/ctx/SellingPageContext';
import { windowUrlParams } from '../../../utils/queryParams';


const SellingModelPage = ({ data }: PageProps<Queries.SellingModelPageQuery>) => {
  const { brands, model, models } = data;

  return (
    <Layout footerColor='bg-gray'>
      <Seo title="Selling ">
        <link rel="preconnect" href={`${API_BASE_URL}/elastic_watches`} />
      </Seo>
      {/* <JsonLd<ProductModel>
        item={{
          '@context': 'https://schema.org',
          '@type': 'ProductModel',
          name: model?.name || '',
          brand: {
            '@type': 'Brand',
            name: model?.brand?.name || ''
          }
        }}
      /> */}
      <Provider>
        <SHF brands={brands.nodes} models={models.nodes} model={model.name} />
      </Provider>
    </Layout>
  )
}

// TODO: Could be moved to a HOC
// TODO: types
const SHF = ({ brands, models, brand, model }: { brands: Queries.Brand[], models: Queries.Model[], brand: string, model: string }) => {
  const [, setStore] = useStore((store) => store);

  useEffect(() => {
    const page = Number(windowUrlParams?.get('page') || initialStore.page);

    setStore({
      models,
      brands,
      page,
      preFilteredBrand: brand,
      selectedBrands: [brand],
      preFilteredModel: model,
      selectedModels: [model]
    })
  }, [])

  return (
    <SellingHeroFilter />
  )
}

export default SellingModelPage

export const query = graphql`
  query SellingModelPage($language: String!, $slug: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    model: model(active: {eq: true}, slug: {eq: $slug}) {
      name
      brand {
        name
      }
    }
    brands: allBrand(filter: {active: {eq: true}}) {
      nodes {
        name
      }
    }
    models: allModel(filter: {active: {eq: true}}) {
      nodes {
        name
        brand {
          name
        }
      }
    }
  }
`
